//import {Mutex} from 'async-mutex'

class AudioManager {
  constructor(){
    this.playing = false
    this.prepared = {}
    this.digits = [128,152,154,161,181,182,185,193,194,199,213,216,218,233,243,254,256,261,294,295,296,313,318,321,322,324,342,343,345,346,353,362,383,384,393,398,436,439,441,452,453,454,464,483,534,556,568,593,599,639,649,658,823,825,828,833,854,856,862,891,916,929,942,989]
    this.src = "https://hekademeia-uploads.s3.us-west-2.amazonaws.com/nht/"
    //this.mutex = new Mutex()
    this.testType = "AudioTrial"
  }

  prepareAudio(level,side){
    this.playing=true
    // since audio has to be played from a gesture, we have to preload it
    console.log('preparing audio ('+level+','+side+')')
    // since the download can cause delay, we have to grab the NEXT audio

    let idx = Math.floor(Math.random()*this.digits.length)
    let d = this.digits[idx]
    this.digits.splice(idx,1) // remove from digits
    let a = null
    // For example, “128g8p92_10.wav” is the digit triplet 128 with 8 glimpses comprising 92% of the total duration, with a 10 dB SNR.
    if(this.testType=="RIDTrial"){
        let pct = (11-level)*4+8
        console.log(pct)
        a = new Audio(this.src+"rid/"+d+"g8p"+pct+"_10"+".wav")
    }else{ // AudioTrial
        a = new Audio(this.src+"wav/"+d+"_"+(level)+"__"+side+".wav")
    }
    
   // a.volume = 0 // once we play this, we can do it async (see autoplay policy)
    //this.mutex.acquire().then((release)=>{
      a.onstalled = ()=>{
        console.log('stalled... trying again.')
        a.load()
      }
      a.onended = ()=>{
        // a.currentTime = 0
        // a.volume = 1 // this also cannot be done async...
        this.playing=false
        //release()
      }
      a.play()
    //})

    this.prepared[level] = { audio: a, idx: idx, d:d }

    /*let idx1 = null
    // since the NEXT audio can be two different options, we get them both
    if(level>1){
        idx1 = Math.floor(Math.random()*this.digits.length)
        let d1 = this.digits[idx1]
        let a1 = new Audio(this.src+"wav/"+d1+"_"+(level-1)+"__"+side+".wav")
        a1.volume = 0 // once we play this, we can do it async (see autoplay policy)
        a1.play()
        this.prepared[level-1] = { audio: a1, idx: idx1, d:d1 }
    }

    if(level<11){
        let idx2 = null
        do{ // make sure we don't grab the same ID (we remove it in playAudio)
          idx2 = Math.floor(Math.random()*this.digits.length)
        }while(idx2===idx1)
        let d2 = this.digits[idx2]
        let a2 = new Audio(this.src+"wav/"+d2+"_"+(level+1)+"__"+side+".wav")
        a2.volume = 0
        a2.play()
        this.prepared[level+1] = { audio: a2, idx: idx2, d:d2 }
    }*/
  }

  // the audio must be prepared first, to avoid autoplay policy issues
  playAudio(level){
    let p = this.prepared[level]
    return p.d

    // just ignore this... Apple won't let us do it
    /*if(typeof(this.prepared[level])==="undefined")
      console.error("attempted to play unprepared audio level: "+level)
    let p = this.prepared[level]
    //this.digits.splice(p.idx,1) // remove from digits
    let a = p.audio

    this.mutex.acquire().then((release)=>{
        console.log("playing ("+level+', '+p.d+")");
        a.volume = 1 // ... make sure this gets turned on
        this.playing=true
        a.onended = ()=>{
            this.playing=false
            release()
        }
        a.play()
    })

    return p.d // return the digits*/
  }
}

let a = new AudioManager
export default a
